import React, { useEffect, useRef, useCallback, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { mainProduct_fetchItems_user } from "../../API/Service/mainProductService";
import LoadingSpinner from "../loader/LoadingSpinner";
import CategoryCard from "../User/Cards/CategoryCard";
import Testimonial from "../User/Testimonial/Testimonial";
import ShipDetail from "../User/Shipping/ShipDetail";
import BannerSlider from "../User/Slider/BannerSlider";
import { useNavigate } from "react-router-dom";
import { isSmallScreen } from "../../MIS/Global";
import { encrypt } from "../../MIS/encryption";
import BrandSection from "../Home/BrandSection";
import { handleGetHomeProduct_list } from "./homeModel";
import LogoMarquee from "../Home/LogoMarquee";
import { handleGet_HomePage } from "../Home/homeModel";

const Home = () => {
  const dispatch = useDispatch();
  const navigate=useNavigate();
  const { userMainProducts, mainProductLoading, mainProductCount } = useSelector((state) => state.mainproduct);
  let productBgColor="";
  const sectionRef = useRef(null); // Reference to the specific section
  const [brandLoading, setBrandLoading] = useState(false)
  const [products, setProducts] = useState([])
  const [logos, setLogos] = useState([])

  
  useEffect(() => {
    document.cookie = "unused=mis@123";
    // document.cookie = "unused=mis@123; path=/; SameSite=None";
    // mainProduct_fetchItems_user({ last_id: 0, limit: 100 }, dispatch);
    handleGetHomeProduct_list({setBrandLoading,setProducts})
    handleGet_HomePage({setLogos})
  }, []);
  
   
  return (
    <Container fluid>
      {/* Image Slider Section */}
      
      <Row className="mb-4">
        <Col xs={12}>
          <BannerSlider />
        </Col>
      </Row>

      {/* Specific Section for Main Scroll */}
      {/* <Row>
        <Col xs={12} className="mb-4" style={{ padding: "0" }} ref={sectionRef}>
          {userMainProducts?.map((product, index) => {
            // Determine if the category name has changed
            let shouldPrintCategory =userMainProducts[userMainProducts.length - 1].catgname !== product.catgname;
            if(mainProductCount === userMainProducts.length){shouldPrintCategory=true;}
            if(productBgColor==""){
              productBgColor="#f3e6f8";
            }else if(productBgColor=="#f3e6f8"){
              productBgColor="#f9e2d4";
            }else if(productBgColor=="#f9e2d4"){
              productBgColor="#f7f5c1";
            }else if(productBgColor=="#f7f5c1"){
              productBgColor="#f3e6f8";
            }
            // Alternate row background color when the category changes
            const rowBackgroundColor = productBgColor;

            return (
              <Container
                key={product?.catgid}
                fluid
                style={{
                  backgroundColor: rowBackgroundColor,
                  padding:isSmallScreen()?"10px":"40px",
                  marginBottom: "20px",
                }}
              >
                {shouldPrintCategory && (
                  <Row className="mb-4">
                    <Col xs={12}>
                      <h2>{product.catgname}</h2>
                    </Col>
                  </Row>
                )}
                <Row className="gx-1 gy-1 gx-md-3 gy-md-3">
                  {[...(product?.products || [])]
                    ?.sort((a, b) => a.seqno - b.seqno)?.map((element) => (
                    <Col key={element?.id} xs={6} sm={6} md={4} lg={3} >
                      <CategoryCard product={element} path={`/subcategory/${encrypt(element?.id)}/${element?.productName}`}/>
                    </Col>
                  ))}
                </Row>
              </Container>
            );
          })}
        </Col>
      </Row> */}

      <Row>
        <Col xs={12} className="mb-4" style={{ padding: 0 }} ref={sectionRef}>

          {/* ✅ SIMPLE BOOTSTRAP SPINNER */}
          {brandLoading ? (
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ minHeight: "200px" }}
            >
              <div
                className="spinner-border"
                role="status"
                style={{ width: "2.5rem", height: "2.5rem", color: "#c9a227" }}
              >
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : (
            products?.map((product, index) => {

            // ✅ Check main_products exists and not empty
            if (!product?.main_products || product.main_products.length === 0) {
              return null;
            }

            // ✅ Filter only items that have sub_products
            const validMainProducts = product.main_products.filter(
              (item) => item?.sub_products && item.sub_products.length > 0
            );

            // ✅ If after filtering nothing remains → hide entire section
            if (validMainProducts.length === 0) {
              return null;
            }

            return (
              <div
                key={product?.id}
                style={{
                  marginBottom: "30px",
                  padding: "25px 15px",
                  background: index % 2 === 0 ? "#fdfaf6" : "#f4f8fc",
                  borderRadius: "14px",
                }}
              >

                {/* ===== SECTION TITLE ===== */}
                <div style={{ marginBottom: "16px" }}>
                  <h4
                    style={{
                      fontSize: "20px",
                      fontWeight: "600",
                      marginBottom: "6px",
                      color: "#222",
                    }}
                  >
                    {product?.name}
                  </h4>

                  <div
                    style={{
                      width: "45px",
                      height: "3px",
                      background: "#c9a227",
                      borderRadius: "4px",
                    }}
                  />
                </div>

                {/* ===== Brand Sections (Only Valid Ones) ===== */}
                {validMainProducts.map((item) => (
                  <Row className="mb-3" key={item?.id}>
                    <Col xs={12}>
                      <BrandSection
                        mainProds={item}
                        mainTitle={product?.name}
                        title={item.name}
                        products={item?.sub_products}
                        isSection="home"
                      />
                    </Col>
                  </Row>
                ))}

              </div>
            );
            })
          )}

        </Col>
      </Row>

      {/* Loading Spinner */}
      <Col xs={12} className="d-flex justify-content-center align-items-center">
        <LoadingSpinner isLoading={mainProductLoading || products?.length<=0} />
      </Col>

      {/* Additional Sections */}
      <Row className="mb-4 d-none">
        <Col xs={12}>
          <ShipDetail />
        </Col>
      </Row>
      {/* <Row className="mb-4">
        <Col xs={12}>
          <Testimonial />
        </Col>
      </Row> */}
      <Row className="mb-4">
        <Col xs={12}>
          <LogoMarquee logos={logos}/>
        </Col>
      </Row>
      
    </Container>
  );
};

export default Home;
